module.exports = __webpack_public_path__ + "img/face-viewfinder.1ebd2e8c.svg";